import * as React from "react";
const WorkIcon = (props) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M28.1199 9.30653C26.9866 8.0532 25.0932 7.42653 22.3466 7.42653H22.0266V7.3732C22.0266 5.1332 22.0266 2.35986 17.0132 2.35986H14.9866C9.97322 2.35986 9.97322 5.14653 9.97322 7.3732V7.43986H9.65322C6.89322 7.43986 5.01322 8.06653 3.87989 9.31986C2.55989 10.7865 2.59989 12.7599 2.73322 14.1065L2.74655 14.1999L2.87989 15.5999C2.89322 15.6132 2.91989 15.6399 2.94655 15.6532C3.38655 15.9465 3.83989 16.2399 4.31989 16.5065C4.50655 16.6265 4.70655 16.7332 4.90655 16.8399C7.18655 18.0932 9.69322 18.9332 12.2399 19.3465C12.3599 20.5999 12.9066 22.0665 15.8266 22.0665C18.7466 22.0665 19.3199 20.6132 19.4132 19.3199C22.1332 18.8799 24.7599 17.9332 27.1332 16.5465C27.2132 16.5065 27.2666 16.4665 27.3332 16.4265C27.9466 16.0799 28.5199 15.7065 29.0799 15.2932C29.1066 15.2799 29.1332 15.2532 29.1466 15.2265L29.1999 14.7465L29.2666 14.1199C29.2799 14.0399 29.2799 13.9732 29.2932 13.8799C29.3999 12.5332 29.3732 10.6932 28.1199 9.30653ZM17.4532 18.4399C17.4532 19.8532 17.4532 20.0665 15.8132 20.0665C14.1732 20.0665 14.1732 19.8132 14.1732 18.4532V16.7732H17.4532V18.4399ZM11.8799 7.42653V7.3732C11.8799 5.10653 11.8799 4.26653 14.9866 4.26653H17.0132C20.1199 4.26653 20.1199 5.11986 20.1199 7.3732V7.43986H11.8799V7.42653Z"
      fill="url(#paint0_linear_3639_300861)"
    />
    <path
      opacity={0.4}
      d="M27.3332 16.4002C27.2665 16.4402 27.1999 16.4802 27.1332 16.5202C24.7599 17.9069 22.1332 18.8402 19.4132 19.2935C19.3065 20.5735 18.7465 22.0402 15.8265 22.0402C12.9065 22.0402 12.3465 20.5869 12.2399 19.3202C9.69322 18.9202 7.18655 18.0802 4.90655 16.8135C4.70655 16.7069 4.50655 16.6002 4.31988 16.4802C3.83988 16.2135 3.38655 15.9202 2.94655 15.6269C2.91988 15.6135 2.89322 15.5869 2.87988 15.5735L3.69322 24.2535C3.97322 26.9069 5.06655 29.6402 10.9332 29.6402H21.0932C26.9599 29.6402 28.0532 26.9069 28.3332 24.2402L29.1732 15.2002C29.1599 15.2269 29.1332 15.2535 29.1065 15.2669C28.5332 15.6802 27.9465 16.0669 27.3332 16.4002Z"
      fill="url(#paint1_linear_3639_300861)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3639_300861"
        x1={2.66999}
        y1={22.0664}
        x2={21.5094}
        y2={-3.4225}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFB800" />
        <stop offset={1} stopColor="#FFF500" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3639_300861"
        x1={2.87947}
        y1={29.6401}
        x2={15.0649}
        y2={7.45207}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFB800" />
        <stop offset={1} stopColor="#FFF500" />
      </linearGradient>
    </defs>
  </svg>
);
export default WorkIcon;
